import * as yup from "yup";

export const createMileageSchema = (minimumMileage) =>
  yup.object().shape({
    mileage: yup
      .number()
      .integer("Please enter a valid mileage")
      .min(
        minimumMileage ? minimumMileage : 1,
        `Mileage must be greater than ${minimumMileage ? minimumMileage : "0"}`
      )
      .max(500000, "Mileage must be less than 500000")
      .required("Please enter your mileage")
      .typeError("Please enter your mileage")
  });
